module.exports = __webpack_public_path__ + "static/IMG_0004-e0334089c6d459b15152c8a68cb6d12e.jpeg";